<template>
  <p>{{ $i18n.t('AUTO_TOPUP.IN_PROGRESS') }}</p>
</template>

<script>
  export default {
    name: "AutoTopupInProgress",
    components: {},
    props: {},
    data: function() {
      return {}
    },
    methods: {}
  }
</script>

<style scoped>

</style>
